import React from 'react';
import { messageFormat } from '@clubmed/utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import type { AvailabilityEnum } from 'Components/widgets/product/Product.mapper';
import 'Components/widgets/product/Product.mapper';
type RemainingStock = number | null;
type AvailabilityConfigItem = {
  label:
    | string
    | {
        n: string;
        _1: string;
      };
  color: string;
  icon?: IconName;
};
type AvailabilityConfig = {
  available: AvailabilityConfigItem;
  unavailable: AvailabilityConfigItem;
  unknown: AvailabilityConfigItem;
  remaining: AvailabilityConfigItem;
};
type Props = {
  availability: AvailabilityEnum;
  remainingStock: RemainingStock;
  config: AvailabilityConfig;
};

const computeAvailabilityStatus = ({
  availability,
  remainingStock,
}: {
  availability: AvailabilityEnum;
  remainingStock: RemainingStock;
}): keyof AvailabilityConfig => {
  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

export const Availability = ({ availability, config, remainingStock }: Props) => {
  const availabilityStatus: keyof AvailabilityConfig = computeAvailabilityStatus({
    availability,
    remainingStock,
  });
  const { color, icon, label } = config[availabilityStatus] || {};
  return label ? (
    <span className={`flex flex-none shrink items-center gap-5 text-${color} text-end`}>
      {icon && <Icon name={icon} width="0.8rem" />}
      {messageFormat(label).format({
        count: remainingStock,
      })}
    </span>
  ) : null;
};
